// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"c836ed1c","216":"f7ab1649","730":"26a4e39d","850":"6f986aca"}[chunkId] + ".chunk.css";
};